import { useMutation } from '@tanstack/react-query'
import { saveImport } from '@/lib/api/company/fileProcessing/saveImport/saveImport'
import { ImportedFileLogsSubmitDto } from '@/modules/imports/model/imports.submit.dto'

type Props = {
  companyId: string
  onSuccess: (taskId: string) => void
  uploadTaskId: string|null
  processedFileId: string|null
}

export const useImportMutation = ({
  companyId,
  uploadTaskId,
  processedFileId,
  onSuccess,
}: Props) => {
  return useMutation<string, unknown, any>({
    mutationFn: async (logs: ImportedFileLogsSubmitDto) => {
      if (!logs) return null

      const taskId = crypto.randomUUID()

      const res = await saveImport({
        companyId,
        importId: processedFileId,
        importedFileLogs: logs,
        previousTaskId: uploadTaskId,
        taskId,
      })
      if (res.status !== 200) throw new Error('Upload failed')

      return taskId
    },
    onSuccess: (taskId, importProps) => {
      onSuccess(taskId)
    },
  })
}
